import { SET_VOCAB_CONTENT } from '../vocabActions';
import { SET_PLAYLIST_ITEM_COMPLETED } from '../../common/playlist/playlistActions';
import { VOCAB } from '../../constants/measure';

export const defaultState = {
    isDataFetched: false,
    practice: [{
        stimulus: {},
        possibleResponses: [],
    }],
    questions: [{
        possible_responses: [],
        stimulus: {},
    }],
};

const mapPossibleResponses = (response) => ({
    id: response.id,
    text: response.text,
});

const mapQuestionsContent = (question) => ({
    itemId: question.item_id,
    possibleResponses: question.possible_responses.map(mapPossibleResponses),
    stimulus: {
        audio: question.stimulus.audio,
        text: question.stimulus.text,
    },
});

const reformatVocabTQVMContent = (apiContent) => ({
    assessment: apiContent.assessment,
    measure: apiContent.measure,
    formId: apiContent.form_id,
    grade: apiContent.grade,
    period: apiContent.period,
    practice: apiContent.practice.map(mapQuestionsContent),
    questions: apiContent.questions.map(mapQuestionsContent),
});

const vocabTQVMReducer = (state = defaultState, action) => {
    switch (action.type) {
    case SET_VOCAB_CONTENT.TQVM:
        return {
            ...state,
            isDataFetched: true,
            ...reformatVocabTQVMContent(action.content),
        };
    case SET_PLAYLIST_ITEM_COMPLETED: {
        if (action.measureKey === VOCAB.TQVM) {
            return defaultState;
        }
        return state;
    }
    default:
        return state;
    }
};

export default vocabTQVMReducer;
